import { render, staticRenderFns } from "./CallStatistics.vue?vue&type=template&id=75c8ea0f&scoped=true"
import script from "./CallStatistics.vue?vue&type=script&lang=js"
export * from "./CallStatistics.vue?vue&type=script&lang=js"
import style0 from "./CallStatistics.vue?vue&type=style&index=0&id=75c8ea0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8ea0f",
  null
  
)

export default component.exports